import { render } from "./UpComing.vue?vue&type=template&id=2fd4a4dd"
import script from "./UpComing.vue?vue&type=script&lang=js"
export * from "./UpComing.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./UpComing.vue?vue&type=style&index=0&id=2fd4a4dd&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__